import Vuex from 'vuex';
import axios from 'axios';

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    exp: localStorage.getItem('exp') || null,  // Store exp in state
    email: localStorage.getItem('email') || null ,
    currency: 'EUR', // Default currency
    cartItems: [], // 👈 Add this line
    cartDrawer: false,
    countryCode:null,
  },
  mutations: {
    setToken(state, { token, exp }) {
      state.token = token;
      state.exp = exp;
      
      // Persist in localStorage
      localStorage.setItem('token', token);
      localStorage.setItem('exp', exp);
    },
    clearToken(state) {
      state.token = null;
      state.exp = null;

      // Remove from localStorage
      localStorage.removeItem('token');
      localStorage.removeItem('exp');
    },
    setCurrency(state, newCurrency) {
      state.currency = newCurrency;
    },
    openDrawer(state) {
      state.cartDrawer = !state.cartDrawer;
    },
    closeDrawer(state) {
      state.cartDrawer = false;
    },
    //cart mutations 
    setCartItems(state, items) {
      //state.cartItems = items
       state.cartItems = items.map(item => JSON.parse(JSON.stringify(item)));
       
    },
    addCartItem(state, item) {
      state.cartItems.push(item)
    },
    updateCartItemQuantity(state, { userProductID, variantID, newQuantity }) {
      const item = state.cartItems.find(
        i => i.userProductID === userProductID && i.variantID === variantID
      );
      if (item) {
        item.quantity = newQuantity;
      }
    },
    removeCartItem(state, { userProductID, variantID }) {
      const index = state.cartItems.findIndex(
        i => i.userProductID === userProductID && i.variantID === variantID
      );
      if (index !== -1) {
        state.cartItems.splice(index, 1);
        state.cartItems = JSON.parse(JSON.stringify(state.cartItems));
      }
    },
    clearCartItems(state) {
      state.cartItems = [];
    },
    setCountryCode(state, countryCode){
      if(countryCode){
        state.countryCode = countryCode;
      }
    },
      setEmail(state, email) {
          state.email = email;
          localStorage.setItem('email', email);
        },
      
        clearEmail(state) {
          state.email = '';
          localStorage.removeItem('email');
        },
  },
  actions: {
    async login({ commit, dispatch  }, credentials) {
      try {
        const response = await axios.post('/apis/login', credentials);
        console.log("credentials",credentials);

        const token = response.data.token;
        const exp = response.data.exp;
        const email = credentials.username;
      

        // Commit token to Vuex store and persist in localStorage
        commit('setToken', { token, exp });
        commit('setEmail', email);
        await dispatch('fetchCart');

        return true; // Login successful
      } catch (error) {
        console.error('Login failed:', error);
        return false; // Login failed
      }
    },
    async tempRegister({ commit, dispatch  }, credentials) {
   
      try {
        const response = await axios.post('/apis/tempRegister', credentials);
        const token = response.data.token;
        const exp = response.data.exp;
        const email = credentials.username;

        // Commit token to Vuex store and persist in localStorage
        commit('setToken', { token, exp });
        commit('setEmail', email);
        await dispatch('fetchCart');

        return true;
      } catch (error) {
        console.error('Temporary registration failed:', error);
        return false;
      }
    },
    updateTokenFromUrl({ commit }, { token, exp }) {
      // When receiving token from URL, update Vuex store and localStorage
      commit('setToken', { token, exp });
    },
     logout({ commit }) {
      commit('clearToken');
      commit('clearCartItems'); 
      commit('clearEmail');
    
    },
    updateCurrency({ commit }, newCurrency) {
      commit('setCurrency', newCurrency);
    },
    //cart Actions
    async fetchCart({ commit, state }) {
    
      try {
  
        const res = await axios.post(
          '/apis/getCartItems',
          {
             countryCode: state.countryCode || null , 
          }, 
          {
            headers: {
              Authorization: `${state.token}` 
            }
          }
        );
        commit('setCartItems', res.data);
        return true;
      } catch (error) {
        console.error('Failed to fetch cart:', error)
      }
    },
    async updateCartItemQuantity({ commit, state, dispatch }, { userProductID, variantID, newQuantity }) {
      commit('updateCartItemQuantity', { userProductID, variantID, newQuantity });
    
      try {
        await axios.post('/apis/updateCartQuantity', { userProductID, variantID, quantity: newQuantity }, {
          headers: {
            Authorization: `${state.token}`
          }
        });
    
        // ✅ Refresh cart from backend after successful update
        await dispatch('fetchCart',{'countryCode':state.countryCode});
        return true;
      } catch (err) {
        console.error('Failed to update quantity on backend:', err);
      }
    },
    async removeCartItem({ commit, state, dispatch }, { userProductID, variantID }) {
      commit('removeCartItem', { userProductID, variantID });
    
      try {
        await axios.post('/apis/removeCartItem', { userProductID, variantID }, {
          headers: {
            Authorization: `${state.token}`
          }
        });
    
        // ✅ Refresh cart after removal
        await dispatch('fetchCart',{'countryCode':state.countryCode});
        return true;
      } catch (err) {
        console.error('Failed to remove item on backend:', err);
      }
    },
    
  },
  getters: {
    getToken: state => state.token, // Get the token from the state
    getExp: state => state.exp, 
    isLoggedIn: state => !!state.token,
    currentCurrency: state => state.currency,
    userEmail: state => state.email,
    //cart Getters
    cartItems: state => state.cartItems,
    cartItemCount: state => state.cartItems.length,
    countryCodeState: state => state.countryCode
  },
});
